<ng-container *ngIf="isAdmin">
  <side-bar-navigation class="side-bar-navigation"></side-bar-navigation> 
  <div style="height: 95%; margin-left: 60px;">

    <admin-roles-management *ngIf="activeTab === adminTabs.RoleManagment && !isCalculationModelArea && !isRaciTemplateArea"></admin-roles-management>
    <admin-business-unit *ngIf="activeTab === adminTabs.BusinessUnits && !isCalculationModelArea && !isRaciTemplateArea"></admin-business-unit>
    <admin-user-management *ngIf="activeTab === adminTabs.Users && !isCalculationModelArea && !isRaciTemplateArea"></admin-user-management>
  
  

    <calculation-model-view *ngIf="isCalculationModelArea && activeTab !== adminTabs.CalculationModelNone">
    </calculation-model-view>

    <calculation-model-edit *ngIf="activeTab === adminTabs.CalculationModelEdit"
                            (closePane)="closeCalculationModelTemplatePane()"
                            (closeWithRefresh)="refreshCalculationModelGrid()">
    </calculation-model-edit>

    <calculation-model-register *ngIf="activeTab === adminTabs.CalculationModelRegister"
                                (closePane)="closeCalculationModelTemplatePane()"
                                (closeWithRefresh)="refreshCalculationModelGrid()">
    </calculation-model-register>
    <raci-template-view *ngIf="isRaciTemplateArea && activeTab !== adminTabs.RaciTemplateNone"></raci-template-view>
    <raci-template-new *ngIf="activeTab === adminTabs.RaciTemplateNew"
                       (closePane)="closeRaciTemplateNewPane()" (closeWithRefresh)="refreshRaciTemplateGrid()"></raci-template-new>
    <raci-template-edit *ngIf="activeTab === adminTabs.RaciTemplateEdit"
                        (closePane)="closeRaciTemplateNewPane()" (closeWithRefresh)="refreshRaciTemplateGrid()"></raci-template-edit>
    <localization-host *ngIf="activeTab === adminTabs.LocalizationHost"></localization-host>
    <localization-form-host [reportTemplate]="reportDesignerTemplate"
                            [selectedItem]="selectedLocalizationGridItem"
                            [reportDesignerLanguageId]="reportDesignerLanguageId"
                            *ngIf="activeTab === adminTabs.LocalizationForm"></localization-form-host>
  </div>
  <ng-container>
    <app-confirm-dialog></app-confirm-dialog>
  </ng-container>
</ng-container>
<data-loader></data-loader>
